import { Ng2StateDeclaration } from '@uirouter/angular';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { DocumentTemplateListViewComponent } from '@fi-app/document-template/document-template-list-view/document-template-list-view.component';
import { DocumentTemplateListComponent } from '@fi-app/document-template/document-template-list/document-template-list.component';

export const FiDocumentTemplateListState: Ng2StateDeclaration = {
    name: FiStateNames.Document.Template.List,
    url: '/?:filterType&:sortColumn&:sortDirection&:offset',
    component: DocumentTemplateListComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, FiDocumentTemplateListStateResolvePageTitleResolveFunc],
    },
};

export function FiDocumentTemplateListStateResolvePageTitleResolveFunc(pageTitleService: PageTitleService) {
    return pageTitleService.setTitleByItem(ObjectTypes.Template);
}
